import { PocTypography } from 'commons/components/components-wrapper';
import { useTranslation } from 'core/i18n/i18n';
import {
    ModalSectionChildrenLayout,
    ModalSectionDescriptionLayout,
    ModalSectionLayout,
    ModalSectionTitleLayout,
} from './modal-dialog-section.style';

export interface ModalDialogSectionProps extends React.PropsWithChildren {
    title?: string;
    description?: string;
    options?: React.ReactNode;
}

export const ModalDialogSection: React.FC<ModalDialogSectionProps> = (props) => {
    const { title, description, children, options } = props;
    const { t } = useTranslation();

    return (
        <ModalSectionLayout>
            {title ? (
                <ModalSectionTitleLayout>
                    <PocTypography element="span" variant="button">
                        {t(title)}
                    </PocTypography>
                    {options}
                </ModalSectionTitleLayout>
            ) : undefined}
            {description ? (
                <ModalSectionDescriptionLayout>
                    <PocTypography element="p" variant="body2">
                        {t(description)}
                    </PocTypography>
                </ModalSectionDescriptionLayout>
            ) : undefined}
            <ModalSectionChildrenLayout>{children}</ModalSectionChildrenLayout>
        </ModalSectionLayout>
    );
};
